// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3037) return "static/chunks/3037-69cb700634f8880b.js";
	if (chunkId === 3201) return "static/chunks/3201-46de98eb452b7ffc.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5957":"bb02c0f2","6925":"2c386607","7270":"1644ddea"}[chunkId] || chunkId) + "." + {"1949":"f252b07dda196ec1","5957":"d6a7f371a5633b34","6925":"f249ab703c598161","7270":"89c5735d4bdd3028"}[chunkId] + ".js";
};